import { isAfter, isBefore, parseISO } from 'date-fns';
import productTypes from '@general/productTypes';

export const getAttendeeListUrl = eventUrl => {
    const urlSegments = eventUrl.split('/');
    return `/attend-and-learn/events/attendees/${urlSegments[urlSegments.length - 1]}`;
};

export const checkForAlreadyRegistered = (event, viewerEvents) => {
    return viewerEvents.map(viewerEvent => viewerEvent.code).includes(event.code);
};

export const checkForRegistrationCutoff = event => {
    if (!event.registrationCutoff) {
        return false;
    }

    const cutoff = new Date(event.registrationCutoff);
    const now = new Date();
    return isAfter(now, cutoff);
};

export const checkForRegistrationFuture = event => {
    if (!event.registrationStart) {
        return false;
    }

    const start = new Date(event.registrationStart * 1000);
    const now = new Date();
    return isAfter(start, now);
};

export const checkIfMembershipWillLapse = ({ member, event, cart }) => {
    const paidThru = parseISO(member.paid_thru);
    const eventStart = parseISO(event.begins_at);
    const isMembershipInCart = cart
        ? cart.items.some(item => item.product_type === productTypes.MEMBERSHIP && item.member_id === member.id)
        : false;

    if (!member.paid_thru) {
        return true;
    }

    if (!member.company?.id && !member.deferred_company?.id) {
        return false;
    }

    if (isAfter(paidThru, eventStart)) {
        return false;
    }

    if (isMembershipInCart) {
        return false;
    }

    if (member.student) {
        return false;
    }

    if (event.locale !== 'US') {
        return false;
    }

    return true;
};
